import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from "react-intl";

import "../../theme/styles.css";
import { withStyles } from "@material-ui/core/styles";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import Header from "../../components/Header";
import AppStoreLink from "../../components/AppStoreLink";
import DetailerWhyChooseUs from "../../components/DetailerWhyChooseUs";
import DetailerHowItWorks from "../../components/DetailerHowItWorks";
import SignUpLink from "../../components/SignUpLink";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  },
  textField: {
    flex: 1,
    marginTop: theme.spacing.unit,
    marginBottom: 0
  },
  button: {
    marginTop: theme.spacing.unit * 2
  }
});

class DetailerPitchScreen extends Component {
  static propTypes = {
    intl: PropTypes.shape({}).isRequired
  };

  translateMessage = messageID => {
    const { intl } = this.props;
    return intl.formatMessage({ id: messageID });
  };

  render() {
    const componentName = "DetailerPitchScreen";

    return (
      <div id="homePage">
        <NavBar forDetailer />

        <Header
          title={this.translateMessage(`${componentName}.Title`)}
          subtitle={this.translateMessage(`${componentName}.Subtitle`)}
        />

        <article>
          <h1>
            <FormattedMessage id={`${componentName}.WhatIsTitle`} />
          </h1>
          <img
            src={require("../../images/detailer/duck_detail.png")}
            alt="Mucky Duck"
            className="imageDetailer"
          />
          <FormattedHTMLMessage id={`${componentName}.WhatIsContent`} />

          <DetailerWhyChooseUs />

          <DetailerHowItWorks />

          <SignUpLink />

          <AppStoreLink />
        </article>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles)(injectIntl(DetailerPitchScreen));



// WEBPACK FOOTER //
// ./src/screens/detailer/DetailerPitchScreen.js